import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Filter, Sliders, Box, Calendar, StopCircle, User, FileText } from "react-feather";
import Select from "react-select";
import { Link } from "react-router-dom";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Breadcrumbs from "../../core/breadcrumbs";
import { apiClient } from "../../services/apiClient";
import { useToast } from "../../Toaster/ToastContext";

const SupplierReport = () => {
  const { showToast } = useToast();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [isFilterVisibleTwo, setIsFilterVisibleTwo] = useState(false);
  const [isFilterVisibleThree, setIsFilterVisibleThree] = useState(false);
  const [supplierData, setSupplierData] = useState([]);

  const toggleFilterVisibility = () => setIsFilterVisible((prev) => !prev);
  const toggleFilterVisibilityTwo = () => setIsFilterVisibleTwo((prev) => !prev);
  const toggleFilterVisibilityThree = () => setIsFilterVisibleThree((prev) => !prev);

  // Sort options
  const options = [
    { value: "sortByDate", label: "Sort by Date" },
    { value: "140923", label: "14 09 23" },
    { value: "110923", label: "11 09 23" },
  ];

  // Dynamic dropdown options
  const productOptions = [
    { value: "chooseProduct", label: "Choose Product" },
    // No product_name in API response, so static for now
    { value: "unknown", label: "Unknown" },
  ];

  const statusOptions = [
    { value: "chooseStatus", label: "Choose Status" },
    ...new Set(
      supplierData.map((item) => ({
        value: item.status || "Unknown",
        label: item.status || "Unknown",
      }))
    ),
  ];

  const supplierNameOptions = [
    { value: "chooseSupplierName", label: "Choose Supplier Name" },
    ...new Set(
      supplierData.map((item) => ({
        value: item.supplier_name || "Unknown",
        label: item.supplier_name || "Unknown",
      }))
    ),
  ];

  const nameOptions = [
    { value: "chooseName", label: "Choose Name" },
    ...new Set(
      supplierData.map((item) => ({
        value: item.supplier_name || "Unknown",
        label: item.supplier_name || "Unknown",
      }))
    ),
  ];

  const statusOptions2 = [
    { value: "chooseStatus", label: "Choose Status" },
    ...new Set(
      supplierData.map((item) => ({
        value: item.status || "Unknown",
        label: item.status || "Unknown",
      }))
    ),
  ];

  const paymentStatusOptions = [
    { value: "choosePaymentStatus", label: "Choose Payment Status" },
    // No payment_status in API response, so static for now
    { value: "unknown", label: "Unknown" },
  ];

  // Date range picker settings
  const initialSettings = {
    endDate: new Date(),
    ranges: {
      "Last 30 Days": [
        new Date(new Date().setDate(new Date().getDate() - 30)),
        new Date(),
      ],
      "Last 7 Days": [
        new Date(new Date().setDate(new Date().getDate() - 7)),
        new Date(),
      ],
      "Last Month": [
        new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
        new Date(new Date().getFullYear(), new Date().getMonth(), 0),
      ],
      "This Month": [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      Today: [new Date(), new Date()],
      Yesterday: [
        new Date(new Date().setDate(new Date().getDate() - 1)),
        new Date(new Date().setDate(new Date().getDate() - 1)),
      ],
    },
    startDate: new Date(new Date().setDate(new Date().getDate() - 7)), // Default to Last 7 Days
    timePicker: false,
  };

  // Fetch supplier report
  const fetchSupplierReport = async () => {
    try {
      const response = await apiClient.post(`/generateSupplierReport`, {
        type: "preview",
      });
      if (response?.success && Array.isArray(response.data)) {
        setSupplierData(response.data);
      } else {
        setSupplierData([]);
        showToast("No supplier data found", "warning");
      }
    } catch (error) {
      console.error("Failed to fetch supplier report:", error);
      showToast("Failed to fetch supplier report", "error");
    }
  };

  useEffect(() => {
    fetchSupplierReport();
  }, []);

  // Handle Excel export
  const handleExportExcel = async () => {
    try {
      const response = await apiClient.post(`/generateSupplierReport`, {});
      const fileUrl = response?.path;

      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "supplier-report.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        showToast("Supplier report exported to Excel successfully", "success");
      } else {
        showToast("No file URL found in response", "error");
      }
    } catch (error) {
      showToast("Failed to export supplier report to Excel", "error");
    }
  };

  // Render purchase rows
  const renderPurchaseRows = () => {
    return supplierData.map((item) => (
      <tr key={item.id}>
        <td>
          <label className="checkboxs">
            <input type="checkbox" />
            <span className="checkmarks" />
          </label>
        </td>
        <td>{"N/A"}</td> {/* No purchase_date in response */}
        <td className="productimgname">
          <div className="view-product me-2">
            <Link to="#">
              <ImageWithBasePath
                src="assets/img/products/default.png"
                alt="product"
              />
            </Link>
          </div>
          <Link to="#">{"Unknown"}</Link> {/* No product_name in response */}
        </td>
        <td>{item.amount ? `$${parseFloat(item.amount).toFixed(2)}` : "N/A"}</td>
        <td>{item.total_items || "N/A"}</td>
        <td>{"N/A"}</td> {/* No paid in response */}
        <td>{"N/A"}</td> {/* No balance in response */}
        <td>
          <span className="badges status-badge">{item.status || "N/A"}</span>
        </td>
      </tr>
    ));
  };

  // Render payment rows
  const renderPaymentRows = () => {
    return supplierData.map((item) => (
      <tr key={item.id}>
        <td>
          <label className="checkboxs">
            <input type="checkbox" />
            <span className="checkmarks" />
          </label>
        </td>
        <td>{"N/A"}</td> {/* No date in response */}
        <td>{"N/A"}</td> {/* No purchase_id in response */}
        <td>{item.reference || "N/A"}</td>
        <td>{item.supplier_name || "N/A"}</td>
        <td>{item.amount ? `$${parseFloat(item.amount).toFixed(2)}` : "N/A"}</td>
        <td>{"N/A"}</td> {/* No paid in response */}
        <td>{item.payment_method || "N/A"}</td>
      </tr>
    ));
  };

  // Render return rows
  const renderReturnRows = () => {
    return supplierData.map((item) => (
      <tr key={item.id}>
        <td>
          <label className="checkboxs">
            <input type="checkbox" />
            <span className="checkmarks" />
          </label>
        </td>
        <td>{item.reference || "N/A"}</td>
        <td>{item.supplier_name || "N/A"}</td>
        <td>{item.amount ? `$${parseFloat(item.amount).toFixed(2)}` : "N/A"}</td>
        <td>{"N/A"}</td> {/* No paid in response */}
        <td>{"N/A"}</td> {/* No due_amount in response */}
        <td>
          <span className="badges status-badge">{item.status || "N/A"}</span>
        </td>
        <td>
          <span className="badge-lineunknown">{"N/A"}</span> {/* No payment_status in response */}
        </td>
      </tr>
    ));
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <Breadcrumbs
          maintitle="Supplier Report"
          subtitle="Manage Your Supplier Report"
          onExcelClick={handleExportExcel}
        />
        <div className="table-tab">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="purchase-report-tab"
                data-bs-toggle="pill"
                data-bs-target="#purchase-report"
                type="button"
                role="tab"
                aria-controls="purchase-report"
                aria-selected="true"
              >
                Purchase
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="payment-report-tab"
                data-bs-toggle="pill"
                data-bs-target="#payment-report"
                type="button"
                role="tab"
                aria-controls="payment-report"
                aria-selected="false"
              >
                Payment
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="return-report-tab"
                data-bs-toggle="pill"
                data-bs-target="#return-report"
                type="button"
                role="tab"
                aria-controls="return-report"
                aria-selected="false"
              >
                Return
              </button>
            </li>
          </ul>
          <div className="tab-content" id="pills-tabContent">
            {/* Purchase Tab */}
            <div
              className="tab-pane fade show active"
              id="purchase-report"
              role="tabpanel"
              aria-labelledby="purchase-report-tab"
            >
              <div className="card table-list-card">
                <div className="card-body">
                  <div className="table-top">
                    <div className="search-set">
                      <div className="search-input">
                        <input
                          type="text"
                          placeholder="Search"
                          className="form-control form-control-sm formsearch"
                        />
                        <Link to="#" className="btn btn-searchset">
                          <i data-feather="search" className="feather-search" />
                        </Link>
                      </div>
                    </div>
                    <div className="search-path">
                      <Link
                        className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`}
                        id="filter_search"
                        onClick={toggleFilterVisibility}
                      >
                        <Filter className="filter-icon" />
                        <span>
                          <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                        </span>
                      </Link>
                    </div>
                    <div className="form-sort stylewidth">
                      <Sliders className="info-img" />
                      <Select className="select" options={options} placeholder="Sort by Date" />
                    </div>
                  </div>
                  <div
                    className={`card ${isFilterVisible ? "visible" : ""}`}
                    id="filter_inputs"
                    style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="row">
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <Box className="info-img" />
                            <Select className="select" options={productOptions} placeholder="Choose Product" />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <StopCircle className="info-img" />
                            <Select className="select" options={statusOptions} placeholder="Choose Status" />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <div className="position-relative daterange-wraper">
                              <Calendar className="feather-14 info-img" />
                              <DateRangePicker initialSettings={initialSettings}>
                                <input
                                  className="form-control col-4 input-range"
                                  type="text"
                                  style={{ border: "none" }}
                                />
                              </DateRangePicker>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                          <div className="input-blocks">
                            <Link to="#" className="btn btn-filters ms-auto">
                              <i data-feather="search" className="feather-search" /> Search
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table datanew">
                      <thead>
                        <tr>
                          <th className="no-sort">
                            <label className="checkboxs">
                              <input type="checkbox" id="select-all" />
                              <span className="checkmarks" />
                            </label>
                          </th>
                          <th>Purchase Date</th>
                          <th>Product</th>
                          <th>Purchase Amount</th>
                          <th>Purchase Qty</th>
                          <th>Paid</th>
                          <th>Balance</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {supplierData.length > 0 ? (
                          renderPurchaseRows()
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* Payment Tab */}
            <div
              className="tab-pane fade"
              id="payment-report"
              role="tabpanel"
              aria-labelledby="payment-report-tab"
            >
              <div className="card table-list-card">
                <div className="card-body">
                  <div className="table-top">
                    <div className="search-set">
                      <div className="search-input">
                        <input
                          type="text"
                          placeholder="Search"
                          className="form-control form-control-sm formsearch"
                        />
                        <Link to="#" className="btn btn-searchset">
                          <i data-feather="search" className="feather-search" />
                        </Link>
                      </div>
                    </div>
                    <div className="search-path">
                      <Link
                        className={`btn btn-filter ${isFilterVisibleTwo ? "setclose" : ""}`}
                        id="filter_search"
                        onClick={toggleFilterVisibilityTwo}
                      >
                        <Filter className="filter-icon" />
                        <span>
                          <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                        </span>
                      </Link>
                    </div>
                    <div className="form-sort stylewidth">
                      <Sliders className="info-img" />
                      <Select className="select" options={options} placeholder="Sort by Date" />
                    </div>
                  </div>
                  <div
                    className={`card ${isFilterVisibleTwo ? "visible" : ""}`}
                    id="filter_inputs1"
                    style={{ display: isFilterVisibleTwo ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="row">
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <User className="info-img" />
                            <Select className="select" options={supplierNameOptions} placeholder="Choose Supplier Name" />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <Calendar className="info-img" />
                            <div className="position-relative daterange-wraper">
                              <DateRangePicker initialSettings={initialSettings}>
                                <input
                                  className="form-control col-4 input-range"
                                  type="text"
                                  style={{ border: "none" }}
                                />
                              </DateRangePicker>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <FileText className="info-img" />
                            <input type="text" placeholder="Enter Reference" />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                          <div className="input-blocks">
                            <Link to="#" className="btn btn-filters ms-auto">
                              <i data-feather="search" className="feather-search" /> Search
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table datanew">
                      <thead>
                        <tr>
                          <th className="no-sort">
                            <label className="checkboxs">
                              <input type="checkbox" id="select-all2" />
                              <span className="checkmarks" />
                            </label>
                          </th>
                          <th>Date</th>
                          <th>Purchase</th>
                          <th>Reference</th>
                          <th>Supplier Name</th>
                          <th>Amount</th>
                          <th>Paid</th>
                          <th>Paid By</th>
                        </tr>
                      </thead>
                      <tbody>
                        {supplierData.length > 0 ? (
                          renderPaymentRows()
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* Return Tab */}
            <div
              className="tab-pane fade"
              id="return-report"
              role="tabpanel"
              aria-labelledby="return-report-tab"
            >
              <div className="card table-list-card">
                <div className="card-body">
                  <div className="table-top">
                    <div className="search-set">
                      <div className="search-input">
                        <input
                          type="text"
                          placeholder="Search"
                          className="form-control form-control-sm formsearch"
                        />
                        <Link to="#" className="btn btn-searchset">
                          <i data-feather="search" className="feather-search" />
                        </Link>
                      </div>
                    </div>
                    <div className="search-path">
                      <Link
                        className={`btn btn-filter ${isFilterVisibleThree ? "setclose" : ""}`}
                        id="filter_search"
                        onClick={toggleFilterVisibilityThree}
                      >
                        <Filter className="filter-icon" />
                        <span>
                          <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                        </span>
                      </Link>
                    </div>
                    <div className="form-sort stylewidth">
                      <Sliders className="info-img" />
                      <Select className="select" options={options} placeholder="Sort by Date" />
                    </div>
                  </div>
                  <div
                    className={`card ${isFilterVisibleThree ? "visible" : ""}`}
                    id="filter_inputs2"
                    style={{ display: isFilterVisibleThree ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="row">
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <User className="info-img" />
                            <Select className="select" options={nameOptions} placeholder="Choose Name" />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <StopCircle className="info-img" />
                            <Select className="select" options={statusOptions2} placeholder="Choose Status" />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12">
                          <div className="input-blocks">
                            <ImageWithBasePath
                              src="assets/img/icons/payment-status.svg"
                              className="info-img status-icon"
                              alt="Icon"
                            />
                            <Select className="select" options={paymentStatusOptions} placeholder="Choose Payment Status" />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                          <div className="input-blocks">
                            <Link to="#" className="btn btn-filters ms-auto">
                              <i data-feather="search" className="feather-search" /> Search
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table datanew">
                      <thead>
                        <tr>
                          <th className="no-sort">
                            <label className="checkboxs">
                              <input type="checkbox" id="select-all3" />
                              <span className="checkmarks" />
                            </label>
                          </th>
                          <th>Reference</th>
                          <th>Supplier Name</th>
                          <th>Amount</th>
                          <th>Paid</th>
                          <th>Due Amount</th>
                          <th>Status</th>
                          <th>Payment Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {supplierData.length > 0 ? (
                          renderReturnRows()
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierReport;